export default {
  title: 'Track order',
};
